<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-top">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel" data-v-step-routing-form-step-2="1">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" :disabled="loading" @click="previousStep" data-v-step-routing-form-step-2="2">
                            <i class="fa fa-fw fa-caret-left"></i> VOLTAR
                        </button>
                        <button class="button-edit" style="float: right;" :disabled="loading" @click="nextStep();" data-v-step-routing-form-step-2="3">
                            PRÓXIMA <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                        </button>
                        <button class="btn button-edit button-cancel btn-right" @click="$refs.tour.editTour()">
                            <i class="fas fa-question-circle"></i> TOUR
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-heading">
                <div class="row">
                    <div class="col-xs-12 col-lg-12 heading-page">
                        <small><b>Selecione os veículos</b> <span v-popover:tooltip.right="'Selecione os veículos que participarão do roteiro'"><i class="fas fa-question-circle"></i></span></small>
                    </div>
                </div>
            </div>
            <div class="container-filter" data-v-step-routing-form-step-2="4">
                <div class="row">
                    <div class="col-xs-12 col-lg-12 collapse-header" @click="show_filters = !show_filters">
                        <div class="container-collapse-header">
                            <span><b><i class="fa fa-fw fa-sliders-h"></i> Filtros</b></span>
                            <span class="collapse-header-arrow" v-if="show_filters"><i class="fa fa-chevron-up"></i></span>
                            <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                        </div>
                    </div>
                    <div v-if="show_filters" class="col-xs-12 col-lg-12 container-collapse-body">
                        <div class="collapse-body">
                            <div class="row">
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelectCourses v-model="filters.license_plate" label="Placa" :options="optionsMyVehicles" :multiple="true" :required="false" ref="license_plate_filter" tooltip="Informe a placa da veículo" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelectCourses v-model="filters.brand" label="Marca" :options="options.brand" :multiple="true" :required="false" ref="brand_filter" tooltip="Selecione a marca do veículo" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelectCourses v-model="filters.vehicle_type" label="Tipo" :options="options.vehicle_type" :multiple="true" :required="false" ref="vehicle_type_filter" tooltip="Selecione o tipo do veículo" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelectCourses v-model="filters.bodywork" label="Carroceria" :options="options.bodywork" :multiple="true" :required="false" ref="bodywork_filter" tooltip="Selecione a placa do veículo" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormInput v-model="filters.model" label="Modelo" type="text" :required="false" ref="model_filter" tooltip="Informe o modelo do veículo" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormInputMasked v-model="filters.weight_capacity" label="Capacidade" type="tel" :required="false" :mask="['# kg','## kg','### kg','#### kg','##### kg','###### kg','####### kg','######## kg','######### kg']" ref="weight_capacity_filter" tooltip="Informe a capacidade do veículo" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelect v-model="filters.expanded_center" label="Centro Expandido (SP)" :options="options.expanded_center" :multiple="false" :required="false" :showAllOptions="true" ref="expanded_center_filter" tooltip="Selecione se o veículo acessa o Centro Expandido (Campo voltado para cidade de São Paulo)" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelectCourses v-model="filters.rotation_day" label="Dia do rodízio (SP)" :options="options.rotation_day" :multiple="true" :required="false" ref="rotation_day_filter" tooltip="Selecione o dia de rodízio para excluir os veículos desse dia (Campo voltado para cidade de São Paulo)" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-lg-2">
                                    <button class="add_new_filters" @click="filter_vehicles()">
                                        <i class="fas fa-filter"></i> Filtrar
                                    </button>                                                             
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <button class="add_new_filters" @click="clean_filters()">
                                        <i class="fas fa-eraser"></i> Limpar
                                    </button>                                                             
                                </div>
                            </div>                     
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12 config-tab-container">
            <br/>
            <button class="config-tab" :class="{ 'enabled': (tab == 'list') }" @click="tab = 'list'" data-v-step-routing-form-step-2="5">
                Lista ({{ list.length }})
            </button>
            <button class="config-tab" :class="{ 'enabled': (tab == 'selected') }" @click="tab = 'selected'" data-v-step-routing-form-step-2="6">
                Selecionados ({{ selected.length }})
            </button>
        </div>
        <div class="col-xs-12 col-lg-12 config-tab-block" :class="{ 'show': (tab == 'list') }" data-v-step-routing-form-step-2="7">
            <RoutingTable 
                :loading="loading" 
                :headers="headers" 
                :ordering="ordering" 
                :order="order" 
                :list="list" 
                :page="page" 
                :per_page="per_page" 
                :total="total" 
                :modifiers="modifiers" 
                :label="'veículos'"
                :select_all="select_all" 
                :select_all_return_origin="select_all_return_origin" 
                :on_select="on_select" 
                :on_select_return_origin="on_select_return_origin" 
                :selected="selected_list" 
                :selected_return_origin="selected_list_return_origin" 
                :unselected_return_origin="unselected_list_return_origin"
                :is_selected="false" 
                :selected_weight_capacity="total_weight_capacity" 
                @reorder="(o) => {
                    order = o;
                    load();
                }"
            />
        </div>
        <div class="col-xs-12 col-lg-12 config-tab-block" :class="{ 'show': (tab == 'selected') }">
            <RoutingTable 
                :loading="loading" 
                :headers="headers" 
                :ordering="ordering" 
                :order="order_selected" 
                :list="selected_list" 
                :page="page" 
                :per_page="per_page" 
                :total="selected_list.length" 
                :modifiers="modifiers" 
                :label="'veículos'"
                :select_all="selected_select_all" 
                :select_all_return_origin="select_all_return_origin" 
                :on_select="on_select" 
                :on_select_return_origin="on_select_return_origin" 
                :selected="selected_list" 
                :selected_return_origin="selected_list_return_origin" 
                :unselected_return_origin="unselected_list_return_origin" 
                :is_selected="true"
                :selected_weight_capacity="total_weight_capacity" 
                @reorder="(o) => {
                    order_selected = o;
                    reorder();
                }"
            />
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-bottom">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" :disabled="loading" @click="previousStep">
                            <i class="fa fa-fw fa-caret-left"></i> VOLTAR
                        </button>
                        <button class="button-edit" style="float: right;" :disabled="loading" @click="nextStep();">
                            PRÓXIMA <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Tour
            tour="DeliveryRouting"
            :steps="tour_steps"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import RoutingTable from "../Routing/RoutingTable";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import FormSelectCourses from "@/components/FormSelectCourses";
import Tour from "@/components/Tour";

export default {
    name: "RoutingFormStep2",

    props: {
        data: {
            type: Array,
            require: true,
        },
        my_vehicles: {
            type: Array,
            require: true,
        },
        selected: {
            type: Array,
            require: true,
        },
        selected_return_origin: {
            type: Array,
            require: true,
        },
        unselected_return_origin: {
            type: Array,
            require: true,
        },
        filter_fields: {
            type: Object,
            require: true,
        },
    },

    components: {
        RoutingTable,
        FormInput,
        FormInputMasked,
        FormSelect,
        FormSelectCourses,
        Tour,
    },

    data: function() {
        return {
            loading: false,
            search: "",
            filters: this.filter_fields,

            tab: 'list',

			headers: {
                license_plate: "Placa",
                brand: "Marca",
                vehicle_type: "Tipo",
                bodywork: "Carroceria",
                model: "Modelo",
                weight_capacity: "Capacidade",
                expanded_center: " Centro Expandido (SP)",
                rotation_day: "Rodízio (SP)",
            },
            ordering: ['license_plate', 'brand', 'vehicle_type', 'bodywork', 'weight_capacity'],
            order: 'license_plate-ASC',
            order_selected: 'license_plate-ASC',
            list: [],
            page: 0,
            per_page: 0,
            total: 0,
            modifiers: {
                weight_capacity: function(d) {
                    let weight_formatted = "";
                    if(d < 1000) weight_formatted = d.toFixed(2) + " kg";
                    else weight_formatted = (d / 1000).toFixed(2) + " t";
                    return "<span title='" + weight_formatted.replace(".", ",") + "'>" + weight_formatted.replace(".", ",") + "</span>";
				},

                expanded_center: function(d) {
                    let expanded_center = "";
                    if (d != null) {
                        if (parseInt(d) == 1) expanded_center = "SIM";
                        else expanded_center = "NÃO";
                    } else expanded_center = "NÃO";
                    return "<span title='" + expanded_center + "'>" + expanded_center + "</span>";
                },
                
                rotation_day: function(d, item) {
                    let rotation_day = "";
                    if (item.expanded_center != null) {
                        if (parseInt(item.expanded_center) == 1) {
                            if (item.license_plate.endsWith("1") || item.license_plate.endsWith("2")) {
                                rotation_day = "SEGUNDA-FEIRA";
                            } else if (item.license_plate.endsWith("3") || item.license_plate.endsWith("4")) {
                                rotation_day = "TERÇA-FEIRA";
                            } else if (item.license_plate.endsWith("5") || item.license_plate.endsWith("6")) {
                                rotation_day = "QUARTA-FEIRA";
                            } else if (item.license_plate.endsWith("7") || item.license_plate.endsWith("8")) {
                                rotation_day = "QUINTA-FEIRA";
                            } else if (item.license_plate.endsWith("9") || item.license_plate.endsWith("0")) {
                                rotation_day = "SEXTA-FEIRA";
                            }
                        } else {
                            rotation_day = "NÃO";
                        }
                    }
                    else rotation_day = "NÃO";
                    return "<span title='" + rotation_day + "'>" + rotation_day + "</span>";
				},
            },
            selected_list: this.selected,
            selected_list_return_origin: this.selected_return_origin,
            unselected_list_return_origin: this.unselected_return_origin,

            vehicle_list: this.data,
            
            show_filters: false,

            // Retorna os options
            options: {
                bodywork: {
                    'BAÚ': 'BAÚ',
                    'BAÚ FRIGORÍFICO': 'BAÚ FRIGORÍFICO',
                    'GRADE BAIXA': 'GRADE BAIXA',
                    'GRANELEIRA': 'GRANELEIRA',
                    'PLATAFORMA': 'PLATAFORMA',
                    'PORTA CONTAINER': 'PORTA CONTAINER',
                    'PRANCHA': 'PRANCHA',
                    'SIDER': 'SIDER',
                    'TANQUE': 'TANQUE',
                    'OUTRO': 'OUTRO',
                },
                brand: {
                    'AGRALE': 'AGRALE',
                    'BYD': 'BYD',
                    'DAF': 'DAF',
                    'EFFA (JBC/JMC)': 'EFFA (JBC/JMC)',
                    'FORD': 'FORD',
                    'FOTON': 'FOTON',
                    'HYUNDAI': 'HYUNDAI',
                    'INTERNATIONAL': 'INTERNATIONAL',
                    'IVECO': 'IVECO',
                    'JAC': 'JAC',
                    'MAN': 'MAN',
                    'MERCEDES-BENZ': 'MERCEDES-BENZ',
                    'PETERBILT': 'PETERBILT',
                    'SCANIA': 'SCANIA',
                    'SINOTRUCK': 'SINOTRUCK',
                    'SHACMAN': 'SHACMAN',
                    'VOLKSWAGEN': 'VOLKSWAGEN',
                    'VOLVO': 'VOLVO',
                    'OUTRO': 'OUTRO',
                },
                expanded_center: {
                    0: 'NÃO',
                    1: 'SIM',
                },
                rotation_day: {
                    '1 - 2': 'SEGUNDA-FEIRA',
                    '3 - 4': 'TERÇA-FEIRA',
                    '5 - 6': 'QUARTA-FEIRA',
                    '7 - 8': 'QUINTA-FEIRA',
                    '9 - 0': 'SEXTA-FEIRA',
                },
                vehicle_type: {
                    'CARRO': 'CARRO',
                    'CARRETA': 'CARRETA',
                    'MOTO': 'MOTO',
                    'TOCO': 'TOCO',
                    'TRUCK': 'TRUCK',
                    'UTILITÁRIO': 'UTILITÁRIO',
                    'VAN': 'VAN',
                    'VUC': 'VUC',
                    'OUTRO': 'OUTRO',
                },
            },

            all_selected: true,
            all_selected_return_origin: true,
            total_weight_capacity: 0.00,
            
            tour_steps: [
                {
                    target: '[data-v-step-routing-form-step-2="0"]',
                    header: {
                        title: '<code>PASSO ATUAL</code>',
                    },
                    content: '<code>Verifique aqui o passo atual</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="1"]',
                    header: {
                        title: '<code>CANCELAR</code>',
                    },
                    content: '<code>Clique em <b>CANCELAR</b> para interromper o processo e voltar para lista de roteiros</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="2"]',
                    header: {
                        title: '<code>VOLTAR</code>',
                    },
                    content: '<code>Clique em <b>VOLTAR</b> para voltar para a etapa anterior</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="3"]',
                    header: {
                        title: '<code>CONTINUAR</code>',
                    },
                    content: '<code>Clique em <b>PRÓXIMA</b> para avançar para a etapa seguinte</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="4"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campos de filtragem dos registros</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="5"]',
                    header: {
                        title: '<code>LISTAGEM ATUAL</code>',
                    },
                    content: '<code>Aba de exibição dos registros, clique em <b>LISTA</b> para mostrar a lista de registros atuais</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="6"]',
                    header: {
                        title: '<code>LISTAGEM DE SELEÇÃO</code>',
                    },
                    content: '<code>Aba de exibição dos registros, clique em <b>SELECIONADOS</b> para mostrar a lista de registros selecionados</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-2="7"]',
                    header: {
                        title: '<code>VEÍCULOS</code>',
                    },
                    content: '<code>Lista dos registros de veículos cadastrados</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
        }
    },

    mounted: function() {
        this.load();
        if (this.selected_list.length > 0) this.calcTotalWeightCapacity();
        this.$refs.tour.setTour();
    },

    computed: {
        optionsMyVehicles: function() {
            let vehicles = {};
            this.my_vehicles.map(vehicle => {
				vehicles[vehicle.license_plate] = vehicle.license_plate;
			});
            return vehicles;
        },
    },

    methods: {
        // Requisita a lista
		load: async function(is_search) {
            let form = {};
            
            this.list = [];
			this.total = 0;
            
            form.status = this.filter;
            
            // Verifica se houve uma busca
            if (this.search) form.search = this.search;
			if (is_search) this.page = 0;

            form.page = this.page;
            form.per_page = this.per_page;
            form.filters = this.filters;
            
            // Verifica a ordenação
            if(this.order) form.order = this.order;
            
            // Requisita as informações
            let result = null;
            this.loading = true;
            try {
                result = await Api.post("vehicle/list", form);
            } catch (ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível obter a lista de veículos.");
                return;
            }
			this.loading = false;
            
            // Verifica o resultado
			if (result) {
                // Verifica se houve erro
                if (result.error) {
                    this.$notification.error(result.data);
                    return;
                }

                // Adiciona o padrão de tempo, ou recupera as alteraçõe já feitas
                result.data.map(r => {
                    // Adiciona alterações gerais
                    r.start_lunch_time = this.$parent.data[1].start_lunch_time;
                    r.end_lunch_time = this.$parent.data[1].end_lunch_time;
                    r.average_speed = this.$parent.data[1].average_speed;

                    // Verifica se retorna da origem
                    if(!this.selected_list_return_origin.includes(r.id) && !this.unselected_list_return_origin.includes(r.id)) {
                        if(r.return_origin == 1) {
                            this.selected_list_return_origin.push(r.id);
                        } else {
                            this.unselected_list_return_origin.push(r.id);
                        }
                    }
                });

                this.list = result.data;
                this.total = result.total;
                return;
            } else {
				this.$notification.error("Não foi possível obter a lista.");
				return;
			}
        },

        // Retorna um novo veículo preenchido
        newVehicle: function(item) {
            let newVehicle = new Object();
            
            newVehicle.id = item.id;
            
            newVehicle.license_plate = item.license_plate;
            newVehicle.brand = item.brand;
            newVehicle.vehicle_type = item.vehicle_type;
            newVehicle.bodywork = item.bodywork;
            newVehicle.axles = item.axles ? item.axles : 0;
            newVehicle.model = item.model ? item.model : "";
            newVehicle.average_speed = item.average_speed ? item.average_speed : 40;
            newVehicle.fuel_type = item.fuel_type ?item.fuel_type : "";
            
            newVehicle.start_lunch_time = item.start_lunch_time ? item.start_lunch_time : "00:00";
            newVehicle.end_lunch_time = item.end_lunch_time ? item.end_lunch_time : "00:00";
            
            newVehicle.expanded_center = item.expanded_center ? item.expanded_center : 0;
            newVehicle.minimum_occupancy = item.minimum_occupancy ? item.minimum_occupancy : "";
            newVehicle.volume_capacity = item.volume_capacity ? item.volume_capacity : 0;
            newVehicle.weight_capacity = item.weight_capacity;
            newVehicle.return_origin = this.selected_list_return_origin.includes(item.id) ? 1 : 0;
            
            newVehicle.fk_driver = item.fk_driver ? item.fk_driver : "";
            newVehicle.name = item.name ? item.name : "";
            newVehicle.document = item.document ? item.document : "";

            newVehicle.created_at = item.created_at;
            newVehicle.updated_at = item.updated_at;
            
            return newVehicle;
        },

        // Marca/Desmarca todos os registros
        select_all: function() {
            this.list.map(r => {
                let index = this.selected_list.findIndex(element => element.id == r.id);
                if (this.all_selected) {
                    if(index == -1) {
                        if (r.weight_capacity) this.total_weight_capacity += r.weight_capacity;
                        this.selected_list.push(r);
                        this.vehicle_list.push(this.newVehicle(r));
                    }
                } else {
                    if(index != -1) {
                        if (r.weight_capacity) this.total_weight_capacity -= r.weight_capacity;
                        this.selected_list.splice(index, 1);
                        this.vehicle_list.splice(index, 1);
                    }
                }
            });
            this.all_selected = !this.all_selected;
        },
        
        // Marca/Desmarca todos os registros selecionados
        selected_select_all: function() {
            this.clean_selected();
        },
        
        // Marca/Desmarca todos os registros que devem retornar a origem
        select_all_return_origin: function() {
            if(!this.all_selected_return_origin) {
                this.list.map(r => {
                    if(!this.selected_list_return_origin.includes(r.id)) {
                        this.selected_list_return_origin.push(r.id);
                    }
                    if(this.unselected_list_return_origin.includes(r.id)) {
                        const index = this.unselected_list_return_origin.indexOf(r.id);
                        if(index !== false) {
                            this.unselected_list_return_origin.splice(index, 1);
                        }
                    }
                });
            } else {
                this.list.map(r => {
                    if(!this.unselected_list_return_origin.includes(r.id)) {
                        this.unselected_list_return_origin.push(r.id);
                    }
                    if(this.selected_list_return_origin.includes(r.id)) {
                        const index = this.selected_list_return_origin.indexOf(r.id);
                        if (index !== false) {
                            this.selected_list_return_origin.splice(index, 1);
                        }
                    }
                });
            }
            this.all_selected_return_origin = !this.all_selected_return_origin;
        },
        
        // Marca/desmarca ao selecionar um registro individualmente
        on_select: function(item) {
            let index = this.selected_list.findIndex(element => element.id == item.id);
			if(index == -1) {
                if (item.weight_capacity) this.total_weight_capacity += item.weight_capacity;
				this.selected_list.push(item);
                this.vehicle_list.push(this.newVehicle(item));
			} else {
                if (item.weight_capacity) this.total_weight_capacity -= item.weight_capacity;
                this.selected_list.splice(index, 1);
                this.vehicle_list.splice(index, 1);
			}
            if (this.selected_list.length == 0) this.all_selected = true;
		},
        
        // Marca/desmarca ao selecionar um registro individualmente
        on_select_return_origin: function(item) {
			if(this.selected_list_return_origin.includes(item.id)) {
                this.unselected_list_return_origin.push(item.id);
				const index = this.selected_list_return_origin.indexOf(item.id);
				if (index !== false) {
					this.selected_list_return_origin.splice(index, 1);
				}
			} else {
                this.selected_list_return_origin.push(item.id);
                const index = this.unselected_list_return_origin.indexOf(item.id);
				if(index !== false) {
					this.unselected_list_return_origin.splice(index, 1);
				}
			}
            if (this.selected_list_return_origin.length == 0) this.all_selected_return_origin = true;
		},

        // Valida a lista de registros selecionados
        validation: function() {
            this.loading = true;
            let result = [];
            let error = false;
            
            // Verifica se foi selecionado algum registro
            if(this.selected_list.length > 0) {
                // Verifica se o tamanho é igual a lista dos veículos
                if(this.selected_list.length == this.vehicle_list.length) {
                    result = this.vehicle_list;
                } else {
                    this.$notification.error("Não possível identificar todos os veículos selecionados.");
                    error = true;
                }
            } else {
                this.$notification.error("Selecione ao menos um veículo.");
                error = true;
            }

            this.loading = false;
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return result;
            }
        },

        // Retorna a etapa anterior
        previousStep: function() {
            this.$emit("previous");
        },
        
        // Valida e passa para a próxima etapa
        nextStep: function() {
            let result = this.validation();
            
            if (result != null) {
                this.$emit("next", result);
            }
        },
        
        // Cancela o processo atual
        cancel: function () {
            this.$emit("cancel");
        },

        clean_filters: function() {
            this.filters.license_plate = [];
            this.$refs.license_plate_filter.clear_selected();
            this.filters.brand = [];
            this.$refs.brand_filter.clear_selected();
            this.filters.vehicle_type = [];
            this.$refs.vehicle_type_filter.clear_selected();
            this.filters.bodywork = [];
            this.$refs.bodywork_filter.clear_selected();
            this.filters.model = "";
            this.filters.weight_capacity = "";
            this.filters.expanded_center = "";
            this.$refs.expanded_center_filter = "";
            this.filters.rotation_day = "";
            this.$refs.rotation_day_filter.clear_selected();
        },

        // Limpa a lista de selecionados
        clean_selected: function() {
            this.vehicle_list.length = 0;
            this.selected_list.length = 0;
            this.total_weight_capacity = 0.00;
            this.all_selected = true;
        },
        
        // Limpa a lista de selecionados
        clean_selected_return_origin: function() {
            this.selected_list_return_origin.length = 0;
            this.unselected_list_return_origin.length = 0;
            this.all_selected_return_origin = true;
        },

        filter_vehicles: function() {
            //this.clean_selected();
            this.load();
        },
        
        // Reordena a lista
        reorder: function() {
            this.loading = true;
            let order = this.order_selected.split("-");
            this.selected_list.sort(function(a, b) {
                if (order[0] == "license_plate") {
                    if (order[1] == "ASC") {
                        if (a.license_plate  > b.license_plate) return 1;
                        else if (a.license_plate  < b.license_plate) return - 1;
                        else return 0;
                    } else {
                        if (a.license_plate  < b.license_plate) return 1;
                        else if (a.license_plate  > b.license_plate) return - 1;
                        else return 0;
                    }
                } else if (order[0] == "brand") {
                    if (order[1] == "ASC") {
                        if (a.brand  > b.brand) return 1;
                        else if (a.brand  < b.brand) return - 1;
                        else return 0;
                    } else {
                        if (a.brand  < b.brand) return 1;
                        else if (a.brand  > b.brand) return - 1;
                        else return 0;
                    }
                } else if (order[0] == "vehicle_type") {
                    if (order[1] == "ASC") {
                        if (a.vehicle_type  > b.vehicle_type) return 1;
                        else if (a.vehicle_type  < b.vehicle_type) return - 1;
                        else return 0;
                    } else {
                        if (a.vehicle_type  < b.vehicle_type) return 1;
                        else if (a.vehicle_type  > b.vehicle_type) return - 1;
                        else return 0;
                    }
                } else if (order[0] == "bodywork") {
                    if (order[1] == "ASC") {
                        if (a.bodywork  > b.bodywork) return 1;
                        else if (a.bodywork  < b.bodywork) return - 1;
                        else return 0;
                    } else {
                        if (a.bodywork  < b.bodywork) return 1;
                        else if (a.bodywork  > b.bodywork) return - 1;
                        else return 0;
                    }
                }
            });
            this.loading = false;
        },

        calcTotalWeightCapacity: function() {
            this.selected_list.forEach(element => {
                if (element.weight_capacity) this.total_weight_capacity += element.weight_capacity;
            });
        },
    }
}
</script>

<style scoped>
.container-heading {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-filter {
    background-color: #f0f0f0;
}

.container-collapse-header {
    cursor: pointer;
    padding: 15px;
}

span.collapse-header-arrow {
    float: right;
}

.collapse-body {
    padding: 15px;
	border-top: 1px solid #ddd;
}

.add_new_filters {
	float: right;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;	
    margin-top: 25px;
    width: 100%;
}

.heading-page {
    padding: 7.5px 10px;
}

.container-button-top {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-button-bottom {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #fff;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

.button-cancel {
    color: #595959;
    background-color: #d9d9d9;
}

.config-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.config-tab.enabled {
	background: #fff;
}

.config-tab-container {
    border-bottom: 1px solid #eee;
}

.config-tab-block {
	display: none;
}
.config-tab-block.show {
	display: block;
}
</style>